import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserOnboardingPage.css';
import { postRequest } from '../../api';
import { getPublicPlans } from '../../api/Stripe';
import { notification, Spin } from "antd";

const SubscriptionOption = ({ title, desc, pkg, price, extra, details, detail, buttonText, onConfirm, isSelected, onClick }) => (
  <div 
    className={`subscription-option ${isSelected ? 'selected' : ''}`} 
    onClick={onClick}
  >
    <h2>{title}</h2>
    <div className="desc">
      {desc.map((desc, index) => (
        <p key={index}>{desc}</p>
      ))}
    </div>
    <div className='plan'>
      <p className="pkg">{pkg}</p>
      <span className="price">{price}</span>
    </div>
    <span className="extra">{extra}</span>
    <ul className="details">
      {details.map((details, index) => (
        <li key={index}>{details}</li>
      ))}
    </ul>
    <button className={`confirm-button ${isSelected ? 'confirmed' : ''}`}>
      {isSelected ? 'Selected' : 'Confirm'}
    </button>
        <div className="detail">
      {detail.map((detail, index) => (
        <p key={index}>{detail}</p>
      ))}
    </div>
  </div>
);

const SubscriptionOptions = ({setOnboardingData, onboardingData }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const response = await getPublicPlans();
      console.log('API Response:', response);
      if (response && response.data && response.data.subscriptionPlans) {
        console.log('Plans fetched:', response.data.subscriptionPlans);
        setPlans(response.data.subscriptionPlans);
      }
    } catch (error) {
      console.error('Error fetching plans:', error);
      notification.error({
        message: 'Error',
        description: 'Failed to load subscription plans. Please refresh the page.',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = (option) => {
    setSelectedOption(option);
  };

  const handleNext = async () => {
    if (!selectedOption) {
      notification.warning({
        message: 'Selection Required',
        description: 'Please select a subscription option.',
        duration: 10
      });
      return;
    }
    const planId = selectedOption.title === "One Week Free Trial" ? process.env.REACT_APP_FREE_PLAN : null;
    if (selectedOption.title === "One Week Free Trial") {
      if (planId) {
        try {
          const response = await postRequest('/stripe/create-free-subscription', {
            planId: planId,
          });
          if (response) {
            navigate('/onboarding/get-to-know-you');
          } else {
            notification.error({
              message: 'Error',
              description: 'Failed to create subscription. Please try again.',
            });
          }
        } catch (error) {
          console.error('Error creating free trial subscription:', error);
          notification.error({
            message: 'Error',
            description: 'An error occurred. Please try again.',
          });
        }
      } else {
        notification.error({
          message: 'Error',
          description: 'User ID or Plan ID is missing.',
        });
      }
    } else {
      navigate('/confirm-subs', { state: { selectedOption } });
    }
  };

  // Find monthly and annual plan prices from fetched data
  const monthlyPlan = plans.find(p => p.interval === 'month');
  const annualPlan = plans.find(p => p.interval === 'year');
  
  console.log('Monthly plan:', monthlyPlan);
  console.log('Annual plan:', annualPlan);

  const options = [
    {
      title: "One Week Free Trial",
      pkg: "FREE",
      price: "for one week",
      extra: "",
      desc: ["Trial our basic features free of charge, without having to provide your payment details."],
      details: ["5 minute limited conversations with My Friend", "3 quick links permitted"],
      buttonText: "Confirm",
      detail: [`*After the first week, you can choose to be moved onto the £${monthlyPlan?.price?.toFixed(2) || '7.29'} monthly subscription. The monthly price is subject to change.`]
    },
    {
      title: "Pay Monthly",
      pkg: `£${monthlyPlan?.price?.toFixed(2) || '7.29'}`,
      price: "/month",
      extra: "+ 30p transaction charge",
      desc: ["Access to all our features for free for the first month, then:"],
      details: [],
      buttonText: "Confirm",
      detail: ["*Your subscription will automatically renew, but you can cancel at any time. You must give one month's notice before your subscription is cancelled. The monthly price is subject to change."]
    },
    {
      title: "Pay Annually",
      pkg: `£${annualPlan?.price?.toFixed(2) || '69.90'}`,
      price: "/year",
      extra: "",
      desc: ["Trial our basic features free of charge, without having to provide your payment details."],
      details: ["Get 12 months for the price of 10.", "No transaction fee."],
      buttonText: "Confirm",
      detail: ["*Cancel at any time, but you must have given one month's notice before your subscription is cancelled. The annual price is subject to change."]
    }
  ];

  return (
    <div className="subscription-options">
      <h1 className='heading'>Choose Your Subscription</h1>
      <p className='text'>Please select the payment option that best suits your needs. All options will take you directly to the secure payment provider platform. We have selected to use Stripe as our provider to ensure secure and efficient online protection of your data.</p>
      
      {loading ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
          <p style={{ marginTop: '20px' }}>Loading subscription plans...</p>
        </div>
      ) : (
        <div className="options-container">
          {options.map((option, index) => (
            <SubscriptionOption  
              key={index}
              {...option}
              isSelected={selectedOption?.title === option.title} 
              onClick={() => handleConfirm(option)} 
              onConfirm={() => handleConfirm(option)} 
            />
          ))}
        </div>
      )}
      
      <button className="next-button-1" onClick={handleNext} disabled={loading}>Next</button>
    </div>
  );
};

export default SubscriptionOptions;
